import { createPortalMixpanel } from 'common-ui/portalMixpanel'
import { Path } from './routes/path'

export const mixpanel = createPortalMixpanel({
    token: import.meta.env.VITE_MIXPANEL_TOKEN,
    source: 'billing-server-ui',
    paths: Object.values(Path),
})
